import { combineReducers, configureStore } from "@reduxjs/toolkit";
import alarmsSlice from "./alarmsSlice";
import configurationSlice from "./configurationSlice";
import devicesSlice from "./devicesSlice";
import deviceGroupsSlice from "./deviceGroupsSlice";
import feedsSlice from "./feedsSlice";
import usersSlice from "./usersSlice";
import weatherSlice from "./weatherSlice";
import { APIStatus } from "./APIStatus";
import organizationsSlice from "./organizationsSlice";
import feedRulesSlice from "./feedRulesSlice";
import triggersSlice from "./triggersSlice";
import commentsSlice from "./commentsSlice";
import siteManagementSlice from "./siteManagementSlice";
import resetPasswordSlice from "./resetPasswordSlice";
import setbackManagementSlice from "./setbackManagementSlice";
import assetSlice from "./assetSlice";

const rootReducer = (state, action) => {
  if (action.type === APIStatus.closeSession) {
    state = undefined;
  }
  return combinedReducer(state, action);
};

const combinedReducer = combineReducers({
  devicesSlice: devicesSlice,
  deviceGroupsSlice: deviceGroupsSlice,
  feedsSlice: feedsSlice,
  usersSlice: usersSlice,
  triggersSlice: triggersSlice,
  alarmsSlice: alarmsSlice,
  weatherSlice: weatherSlice,
  configurationSlice: configurationSlice,
  organizationsSlice: organizationsSlice,
  feedRulesSlice: feedRulesSlice,
  commentsSlice: commentsSlice,
  siteManagementSlice: siteManagementSlice,
  resetPasswordSlice: resetPasswordSlice,
  setbackManagementSlice: setbackManagementSlice,
  assetSlice:assetSlice,
});

export const Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: true,
});
